import dynamic from 'next/dynamic'
import { DropdownInputProps } from './DropdownInput/types'
import { PhoneVerificationInputProps } from './PhoneVerificationInput/types'
import { PlainInput } from './PlainInput'
import { PlainInputProps } from './PlainInput/types'
import { SearchInput } from './SearchInput'
import { SearchInputProps } from './SearchInput/types'
import { TextareaInputProps } from './TextareaInput/types'

const PhoneNumberInput = dynamic(() =>
  import('./PhoneNumberInput').then((res) => res.PhoneNumberInput)
)
const DropdownInput = dynamic(() =>
  import('./DropdownInput').then((res) => res.DropdownInput)
)
const TextareaInput = dynamic(() =>
  import('./TextareaInput').then((res) => res.TextareaInput)
)

const CheckboxInput = dynamic(() =>
  import('./CheckBoxInput').then((res) => res.CheckboxInput)
)
const LabelInput = dynamic(() =>
  import('./LabelInput').then((res) => res.LabelInput)
)
const PhoneVerificationInput = dynamic(() =>
  import('./PhoneVerificationInput').then((res) => res.PhoneVerificationInput)
)
const AutoCompleteInput = dynamic(() => import('./AutoCompleteInput'))
const DropdownSearchInput = dynamic(() =>
  import('./DropdownSearchInput').then((res) => res.DropdownSearchInput)
)

export interface BaseInputProps {
  value?: any
  onChange?: (e: any) => void
  onFocus?: (e: any) => void
  onBlur?: (e: any) => void
  onKeyUp?: (e: any) => void
  onAutoCompleteSelect?: (e: any) => void
  size?: 'xs' | 'sm' | 'lg'
  placeholder?: string
  attach?: null | 'top' | 'left' | 'bottom' | 'right' | 'all'
  disabled?: boolean
  type?: 'text' | 'password' | 'number' | 'email'
  stretch?: boolean
  label?: any
  transparent?: boolean
  grow?: boolean
  error?: boolean
  editMode?: boolean
  originalPhoneNumber?: string
  isVerified?: boolean
  backgroundColor?: string
  maxLength?: number
  bottomSheetZIndex?: number
  min?: string
}

interface InputProps
  extends PhoneVerificationInputProps,
    TextareaInputProps,
    SearchInputProps,
    PlainInputProps,
    DropdownInputProps {
  variant: string
}

export const Input: React.FC<InputProps> = ({ variant, ...props }) => {
  const variants = {
    plain: <PlainInput {...props} />,
    search: <SearchInput {...props} />,
    phoneVerification: <PhoneVerificationInput {...props} />,
    textarea: <TextareaInput {...props} />,
    autocomplete: <AutoCompleteInput {...props} />,
    checkbox: <CheckboxInput {...props} />,
    label: <LabelInput {...props} />,
    dropdown: <DropdownInput {...props} />,
    dropdownSearch: <DropdownSearchInput {...props} />,
    phoneNumber: <PhoneNumberInput {...props} />,
  }
  return variants[variant]
}
